import styled from 'styled-components'

export const TitleWrapper = styled.div`
  margin: 24px; 
  padding: 16px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;

  > div {
    margin: 16px 0 0;
  }

  @media (min-width: 600px) {
    align-items: center;
    flex-direction: row;

    > div {
      margin: 0;
    }
  }

  @media (min-width: 768px) {
    flex-direction: column;
    align-items: normal;

    > div {
      margin: 16px 0 0;
    }
  }

  @media (min-width: 900px) {
    align-items: center;
    flex-direction: row;

    > div {
      margin: 0;
    }
  }
`